/*
  Comentários adicionais da correção, como o aluno vê.

  São os textos que o corretor escolheu publicar e pode ter editado. Deliberadamente
  não há nenhuma menção a IA: a IA é ferramenta de apoio do corretor, e quem assina
  a correção é ele.

  Renderiza nada quando não há comentário publicado — a maioria das redações, já que
  isso só existe no fluxo IA + Humano.
*/

const ROTULOS = {
  c1: "Competência 1 — Domínio da norma culta",
  c2: "Competência 2 — Compreensão da proposta",
  c3: "Competência 3 — Seleção e organização de argumentos",
  c4: "Competência 4 — Mecanismos linguísticos",
  c5: "Competência 5 — Proposta de intervenção",
};

/* A coluna é JSON; o driver às vezes devolve objeto, às vezes string. */
function normalizar(bruto) {
  if (!bruto) return null;

  try {
    const obj = typeof bruto === "string" ? JSON.parse(bruto) : bruto;
    if (!obj || typeof obj !== "object") return null;

    const entradas = Object.keys(ROTULOS)
      .filter((k) => typeof obj[k] === "string" && obj[k].trim())
      .map((k) => [k, obj[k].trim()]);

    return entradas.length ? entradas : null;
  } catch {
    return null;
  }
}

function ComentariosAdicionais({ comentarios }) {
  const entradas = normalizar(comentarios);

  if (!entradas) return null;

  return (
    <>
      <hr />
      <table className="table table-striped table-bordered">
        <tbody>
          <tr>
            <td>
              <h3>
                <strong>Comentários adicionais</strong>
              </h3>

              {entradas.map(([chave, texto]) => (
                <div key={chave} className="mb-3">
                  <strong>{ROTULOS[chave]}</strong>
                  {/* pre-wrap preserva as quebras que o corretor deixou no texto */}
                  <div style={{ whiteSpace: "pre-wrap" }}>{texto}</div>
                </div>
              ))}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
}

export default ComentariosAdicionais;
